import WebFont from "webfontloader";
import { useState, useEffect } from "react";

const useFontLoader = (props) => {
  useEffect(() => {
    const fonts = [];
    const check = (props) => {
      if (!props) {
        return;
      }
      Object.keys(props).forEach((key) => {
        if (key === "fontFamily") {
          fonts.push(props[key]);
        } else if (
          typeof props[key] === "object" &&
          typeof props[key] !== null
        ) {
          check(props[key]);
        }
      });
    };
    check(props);
    fonts.forEach((f) => {
      if (!document.fonts.check(`12px '${f}'`)) {
        WebFont.load({
          google: {
            families: [f],
          },
        });
      }
    });
  }, [props]);
};

export default useFontLoader;
